import { useEffect, useState } from "react";

const Brands = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [suppliersLimit, setSuppliersLimit] = useState(24);
  const [loading, setLoading] = useState(true);


  const fetchSuppliers = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        "https://b2bapi.ghayar.com/Customer/Dashboard/GetWebsiteBrands?business_id=250801"
      );

      const json = await res.json();
      setSuppliers(json?.data || []);
    } catch (error) {
      console.error("Error loading supplier brands:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchSuppliers();
  }, []);

  const BrandSkeleton = () => (
    <div
      className="brand-card shimmer"
      style={{
        margin: "5px",
        height: "150px",
        width: "150px",
        background: "#f0f0f0",
        borderRadius: "6px",
      }}
    />
  );


  return (
    <section className="blog-section pb-0" id="Brands">
      <div className="container" data-animation-name="fadeInUpShorter">

        <h1 className="text-center my-5 fw-bold">
          {/* <span>GHAYAR AUTO PARTS STORE:</span> SHOP BY BRANDS */}
          SHOP BY TOP BRANDS AT GHAYAR AUTO PARTS STORE
        </h1>

        <div
          className="row justify-content-center"
          style={{ borderTop: "1px solid #dedede", paddingTop: "20px" }}
        >
          {loading
            ? Array.from({ length: 30 }).map((_, index) => (
              <BrandSkeleton key={`skeleton-${index}`} />
            ))
            : suppliers
              ?.slice(0, suppliersLimit)
              ?.map((sup, index) =>
                sup.SUP_BRAND ? (
                  <div
                    key={`supplier-${index}`}
                    className="brand-card"
                    style={{
                      margin: "5px",
                      height: "150px",
                      width: "150px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    {sup.SUP_WARRANTY && (
                      <img
                        src={`/assets/warranty/${GetWarrantyImage(
                          sup.SUP_WARRANTY
                        )}`}
                        alt="warranty"
                        title={sup.SUP_WARRANTY}
                        style={{
                          width: "50px",
                          position: "absolute",
                          right: "10px",
                          top: "10px",
                          zIndex: 1,
                        }}
                      />
                    )}

                    <ImageWithFallback
                      src={`https://dcapi.carz7.com/sup-logo/${sup.SUP_LOGO_NAME}`}
                      alt={sup.SUP_BRAND}
                      fallbackText={sup.SUP_BRAND}
                    />
                  </div>
                ) : null
              )}
        </div>

        <div className="text-center mt-3">
          <button
            className="text-danger btn"
            onClick={() =>
              setSuppliersLimit(suppliersLimit > 24 ? 24 : suppliers.length)
            }
          >
            {suppliersLimit > 24 ? "Show Less" : "Show More"}
            <i style={{ marginRight: 'unset' }} className={`ri-arrow-${suppliersLimit > 24 ? 'up' : 'down'}-s-line ms-2`}></i>

          </button>
        </div>

      </div>
    </section>
  );
};

/* ================= Helpers ================= */

const GetWarrantyImage = (warranty) => {
  switch (warranty) {
    case "1 Year":
      return "1_warrenty.gif";
    case "6 Months":
      return "6_mh_warrenty.gif";
    case "3 Years":
      return "3_years_warranty.png";
    default:
      return "1_year_warranty.png";
  }
};

const ImageWithFallback = ({ src, alt, fallbackText }) => {
  const [imgError, setImgError] = useState(false);

  return (
    <div
      style={{
        width: "150px",
        height: "80px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
      }}
    >
      {imgError ? (
        <div
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontWeight: "500",
          }}
        >
          {fallbackText}
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
          onError={() => setImgError(true)}
        />
      )}
    </div>
  );
};

export default Brands;
